import React from "react";
import { Tabs, TabPane } from "@/View/Tabs";
import { Swiper, SwiperSlide } from "swiper/react";
import Layout from "@/Layout";
import Collapse, { Panel } from "rc-collapse";
import { getStaticPropsFromStrapiSEOSetting } from "$DATA/seo";
import ImageWithFallback from "@/ImageWithFallback";
import Table from "@/View/Table";
import { BsXLg, BsCheckLg } from "react-icons/bs";

export async function getStaticProps() {
	return await getStaticPropsFromStrapiSEOSetting('/diamond-club'); //參數帶本頁的路徑
}

const tabsForLevelImage = [
    {tabIndex:"general", tabTitle:"สมาชิกทั่วไป", inkColor:"#FFF", buttonAmount:0,},
    {tabIndex:"star", tabTitle:"สมาชิกสตาร์ไลท์", inkColor:"#9B9EECEC", buttonAmount:1,},
    {tabIndex:"vip", tabTitle:"ระดับสมาชิก VIP", inkColor:"#B29E57",  buttonAmount:3,}
]

const VipFaqList = [
    {
        position:"right",
        content:[
            {
                title: <p>ฉันสามารถได้รับแต้มได้อย่างไร?</p>,
                body: "<p>รับแต้มได้ทุกการวางเดิมพันที่ถูกต้อง!</p>"
            },
            {
                title: <p>ทำไมฉันไม่ได้รับแต้มหลังจากเล่น?</p>,
                body: "<p>แต้มจะถูกเครดิตให้กับสมาชิกในวันถัดไป</p>"
            },
            {
                title: <p> ฉันสามารถตรวจสอบแต้มของฉันที่ไหน?</p>,
                body: "<p>คุณสามารถไปที่หน้าบัญชีและไปที่ “รีวอร์ด” เพื่อเช็คแต้มของคุณ<br/>(สามารถใช้ในเวอร์ชันเดสก์ท็อป)</p>"
            },
            {
                title: <p> ฉันสามารถทำอะไรกับแต้มได้บ้าง?</p>,
                body: "<p>แลกรับสินค้าหรือของรางวัล เช่น เงินเดิมพันฟรี, ฟรีสปิน, หรือ สินค้าแบรนด์พรีเมี่ยม<br/>ได้ที่หน้า “รีวอร์ด” ของเรา</p>"
            },
        ]
    },
    {
        position:"left",
        content:[
            {
                title: <p>ฉันสามารถแลกแต้มเป็นเงินสดได้หรือไม่?</p>,
                body: "<p>เราไม่สามารถให้ท่านแลกแต้มเป็นเงินสดได้ แต่คุณสามารถแลกรับสินค้าหน้า “รีวอร์ด”<br/> ของเรา!</p>"
            },
            {
                title: <p>การเลื่อนระดับและการลดระดับจะเกิดขึ้นเมื่อไหร่?</p>,
                body: "<p>เราจะทำการอัปเกรดการเลื่อนระดับ และการลดระดับ วันละ 1 ครั้งทุกวัน</p>"
            },
            {
                title: <p>“รีวอร์ด” คืออะไร??</p>,
                body: "<p>“รีวอร์ด” ให้คุณใช้แต้มของคุณในการแลกรับเงินเดิมพันฟรีฟรีสปิน<br/>และยังมีสินค้าหลากหลาย! (สามารถใช้ได้ในเวอร์ชั่นเดสก์ท็อปเท่านั้น)</p>"
            },
            {
                title: <p>ฉันแลกสินค้าจาก “รีวอร์ด” แล้วแต่ยังไม่ได้รับสินค้า ควรทำอย่างไร?</p>,
                body: "<p>คุณสามารถส่งอีเมลถึงเราพร้อมชื่อผู้ใช้และสินค้าที่แลกไปที่ <a class='link' href='mailto: rewards@fun88.com'>rewards@fun88.com</a><br/>หรือ ติดต่อฝ่ายบริการลูกค้าFun Angel ได้ตลอด 24 ชั่วโมง</p>"
            }
        ]
    },
]

const returnByMemberLevel = [
	["", "สมาชิกทั่วไป","สมาชิกสตาร์ไลท์","ระดับสมาชิก VIP"],
	["กีฬา / อีสปอร์ต", "สูงสุด 0.3%", "สูงสุด 0.5%","สูงสุด 0.5%"],
	["คาสิโน", "สูงสุด 0.6%", "สูงสุด 0.8%","สูงสุด 0.8%"],
	["สล็อต", "สูงสุด 0.8%", "สูงสุด 1.0%","สูงสุด 1.0%"],
	["ยิงปลา", "สูงสุด 0.5%", "สูงสุด 0.8%","สูงสุด 0.8%"],
	["เกม 3 มิติ", "สูงสุด 0.7%", "สูงสุด 0.9%","สูงสุด 0.9%"],
	["หวย", "สูงสุด 0.3%", "สูงสุด 0.5%","สูงสุด 0.5%"],
];

const pointCalculation = [
	["", "สมาชิกทั่วไป", "สมาชิกสตาร์ไลท์", "ระดับสมาชิก VIP"],
	["การคำนวณแต้ม", "คำนวณแต้มทั่วไป", "คำนวณแต้มเพิ่มขึ้น", "คำนวณแต้มเพิ่มขึ้น"],
];

const prizes = [
	["", "ทั่วไป", "สตาร์ไลท์", "ไดมอนด์", "โกล์ด\nไดมอนด์", "สตาร์\nไดมอนด์์"],
	["โบนัสต้อนรับ", <BsXLg/>, <BsXLg/>, "6,000", "15,000", "30,000"],
	["โบนัสวันเกิด", <BsCheckLg/>, <BsCheckLg/>, <BsCheckLg/>, <BsCheckLg/>, <BsCheckLg/>],
	["ของขวัญวันเกิด", <BsXLg/>, <BsXLg/>, <BsCheckLg/>, <BsCheckLg/>, <BsCheckLg/>],
];

const otherBenefit = [
	["", "สมาชิกทั่วไป", "สมาชิกสตาร์ไลท์", "ระดับสมาชิก VIP"],
	["เช็คอินรายวัน", "แต้ม,ฟรีสปิน", "แต้ม,ฟรีสปิน,เงินฟรี", "แต้ม,ฟรีสปิน,เงินฟรี"],
	["ภารกิจพิเศษ", <BsXLg/>, "โบนัสเพิ่มขึ้น","โบนัสเพิ่มขึ้น"],
	["โปรโมชั่นพิเศษ", <BsXLg/>, "โบนัสเพิ่มขึ้น", "โบนัสเพิ่มขึ้น"],
	["โปรโมชั่นเติมเงิน", <BsXLg/>, "เติมเงินรายสัปดาห์", "เติมเงินรายสัปดาห์"],
	["ของขวัญวันหยุดพิเศษ", "ข้อเสนอปกติ", "โอกาสสูงขึ้น,แต้มสูงขึ้น,\nของรางวัลที่ดีกว่า", "โอกาสสูงขึ้น,แต้มสูงขึ้น,\nของรางวัลที่ดีกว่า"],
	["แบรนด์อีเว้นท์", <BsXLg/>, "พิจารณาอันดับ 2", "พิจารณาอันดับ 1"],
	["สินค้าจาก\nแบรนด์", <BsXLg/>, <BsXLg/>, "เสื้อแท้พร้อมลายเซ็น,\nสินค้าแบรนด์พรีเมี่ยม"],
	["ยกระดับการฝากและถอน", <BsXLg/>, "รวดเร็วขึ้น,ตัวเลือกมากขึ้น,\nขีดจำกัดสูงขึ้น", "รวดเร็วขึ้น,ตัวเลือกมากขึ้น,\nขีดจำกัดสูงขึ้น"],
	["ยกระดับบริการ Fun Angels", "ติดต่อ Fun Angels\nบริการลูกค้าทั่วไป", "ยกระดับการติดต่อฝ่ายบริการลูกค้า\nFun Angels", "ยกระดับการติดต่อฝ่ายบริการลูกค้า\nFun Angels"],
];

const expiration = [
	[["เกณฑ์","rowSpan 2"], ["แต้มจากโปรโมชั่น\nหรือกิจกรรม","rowSpan 2"],["แต้มจากยอดหมุนเวียน","colSpan 4"]],
	["สมาชิกซิลเวอร์", "สมาชิกโกลด์", "สมาชิกแพลทินัม", "สมาชิกVIP"],
	["ระยะเวลา\n(นับจากวันที่ได้รับ)", "90 วัน", "60 วัน", "90 วัน", "120 วัน", "180 วัน"],
]

const conditions = [
	"โบนัสต้อนรับสามารถรับได้เพียงครั้งเดียวเมื่ออัปเกรดครั้งแรกเท่านั้น",
	"เว็บไซต์ขอสงวนสิทธิ์ในการมอบของขวัญวันเกิด ในรูปแบบของโบนัสหรือของขวัญตามที่กำหนด",
	"หากระดับสมาชิกถูกลดระดับลงในเดือนเกิด สมาชิกจะไม่มีรับสิทธิ์ของขวัญวันเกิด",
	"สมาชิกต้องมีการฝากเงินอย่างน้อย 1 ครั้งในช่วง 7 วันที่ผ่านมาเพื่อขอรับสิทธิรายวันในมุมรางวัล",
	"สมาชิกต้องลงทะเบียนเป็นสมาชิกมากกว่า 7 วันเพื่อขอรับมิชชั่นรายวัน, รายสัปดาห์ และรายเดือน​",
	"หากสมาชิกไม่สามารถรักษาระดับสมาชิกไดมอนด์และถูกลดระดับ จะสูญเสียสิทธิประโยชน์ที่เกี่ยวข้องทั้งหมด และไม่สามารถเรียกร้องสิทธิประโยชน์ย้อนหลังก่อนการลดระดับได้",
	"เว็บไซต์ขอสงวนสิทธิ์ในการเปลี่ยนแปลง แก้ไข หรือยกเลิกโปรโมชั่นนี้ หรือกรณีใดๆ ก็ตามโดยไม่ต้องแจ้งให้ทราบล่วงหน้า",
	"เพื่ออัปเกรดเป็นสมาชิก VIP หรือเพิ่มระดับ VIP สมาชิกต้องมียอดหมุนเวียนอย่างน้อย 3 เท่าของจำนวนเงินฝาก โดยคำนวณจากช่วงระยะเวลา 90 วันที่ผ่านมา​",
    "สมาชิกสามารถอัปเกรดได้ครั้งละ 1 ระดับ และคะแนนสะสมสำหรับระดับถัดไปจะนับตั้งแต่วันที่อัปเกรดครั้งล่าสุด",
]


function expandIcon({ isActive }) {
    return (
        <i style={{ float: "right" }}>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={1.5}
                stroke="currentColor"
                className="w-6 h-6"
                style={{
                    verticalAlign: "-.125em",
                    transition: "transform .2s",
                    transform: `rotate(${isActive ? -180 : 0}deg)`,
                    float: "right",
                }}
            >
                <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M19.5 8.25l-7.5 7.5-7.5-7.5"
                />
            </svg>
        </i>
    );
}

export default class Main extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            mainTabIndex:undefined,
        };
    }
    onClickMainTab = (tabIndex) => {
		this.setState({mainTabIndex: tabIndex});
    
    }

    rules = () => {
        return [
            {rule:<p>แต้มที่สามารถใช้ในการเลื่อนระดับจะพิจารณาจากยอดหมุนเวียนที่ถูกต้องเท่านั้นแต้มจากโปรโมชั่นจะไม่ถูกนับรวม</p>},
            {rule:
                <p>แต้มจะขึ้นอยู่กับยอดหมุนเวียนที่ถูกต้อง</p>
            },
            {rule:<p>FUN88 ขอสงวนสิทธิ์ในการเปลี่ยนแปลงผลิตภัณฑ์ที่คุณแลกใน “รีวอร์ด” เป็นผลิตภัณฑ์ที่มีมูลค่าเท่ากัน หรือปฏิเสธคำขอแลกหากผลิตภัณฑ์นั้นไม่สามารถใช้งานได้หรือข้อมูลการขอรับไม่สมบูรณ์</p>},
            {rule:<p>การจัดส่งผลิตภัณฑ์จะขึ้นอยู่กับบริการของแต่ละขนส่งที่ให้บริการและระยะเวลาการการดำเนินการของแต่ละขนส่ง</p>},
            {rule:<p>รายละเอียดเพิ่มเติมกรุณาเยี่ยมชม <a 
                    className='link' 
                    target="blank"
                    onClick={() => {
                        global.PopUpLiveChat()
                    }}
                    >
                    คำถามที่พบบ่อย
                </a> หรือ ติดต่อฝ่ายบริการลูกค้า Fun Angel ตลอด 24 ชั่วโมง
            </p>
            },
        ]
    }

    render() {
        const {mainTabIndex} = this.state;
        return (
            <Layout seoData={this.props.seoData} status={6}>
                <div
                    id="DiamondClub"
                    className="common-distance-wrap promotions-content"
                >
                    <div className="common-distance diamond-club-tob-tab">
                        <Tabs
                            id={"mainTab"}
                            className="border-tabs"
                            activeTab={mainTabIndex}
                            dynamicInkWidth={true}
                            onChange={this.onClickMainTab}
                        >
                            <TabPane tabTitle="ระดับสมาชิก" tabIndex="memberLevel">
                                <Tabs id={"subTab"} isInkVisible={false}>
                                    {tabsForLevelImage.map(tab=>{
                                        return (
                                            <TabPane 
                                                data-CN="一般"
                                                tabTitle={tab.tabTitle} 
                                                tabIndex={tab.tabIndex}
                                                inkColor={tab.inkColor} 
                                                prefixIcon={
                                                    <ImageWithFallback
                                                        src={`/${process.env.BASE_PATH}/img/DiamondClub/icon_${tab.tabIndex}.svg`}
                                                        layout="fill"
                                                    />
                                                }
                                            >
                                                <ImageWithFallback
                                                    src={`/${process.env.BASE_PATH}/img/DiamondClub/level_${tab.tabIndex}.svg`}
                                                    layout="fill"
                                                />
                                                <>
                                                    {Array.from({ length: tab.buttonAmount },(cur, i) => {
                                                        return (
                                                            <button 
                                                                className={`fakeButton button_${i}`}
                                                                onClick={()=>{
                                                                    this.setState({mainTabIndex:"detailInfo"})
                                                                }}
                                                            />
                                                        )
                                                    }
                                                )}
                                                </>
                                            </TabPane>
                                        )
                                    })}
                                </Tabs>
                                <div className="levelTextContent">
                                    <div className="horizontalLine" />
                                        {/* 会员等级 */}
                                        {/* 一般會員等級介紹 */}
                                    <div className="levelFaq_box">
                                        <h3>คำถามและคำตอบเกี่ยวกับการเลื่อนระดับและการคำนวณแต้ม</h3>
                                        <div className="faqLists_box">
                                            {VipFaqList.map(part=>{
                                                return (
                                                    <Collapse
                                                        accordion={false}
                                                        destroyInactivePanel
                                                        expandIcon={expandIcon}
                                                        className={`levelFaq_${part.position}`}
                                                    >
                                                        {part.content.map(
                                                            (item, index) => {
                                                                return (
                                                                    <Panel
                                                                        header={item.title}
                                                                        key={index +"list"}
                                                                        showArrow={true}
                                                                    >
                                                                        <div
                                                                            className="FaqContent"
                                                                            dangerouslySetInnerHTML={{
                                                                                __html: item.body,
                                                                            }}
                                                                        />
                                                                    </Panel>
                                                                );
                                                            }
                                                        )}
                                                    </Collapse>
                                                )
                                            })}
                                        </div>
                                    </div>
                                    <div className="ruleList_box">
                                        <h3 data-CN="條款與條件">
                                            ข้อกำหนดและเงื่อนไข
                                        </h3>
                                        <ol className='ruleList'>
                                            {this.rules().map((rule, i)=>{
                                                return <li key={i}>{rule.rule}</li>;
                                            })}
                                        </ol>
                                    </div>
                                </div>
                            </TabPane>
                            <TabPane tabTitle={"สิทธิประโยชน์"} tabIndex={"detailInfo"}>
                                {/* 详情 */}
                                <div className='detailContent'>
                                    <div className="TopBanner">
                                        <img
                                            src="/th/img/diamondClub/bannerDetail.jpg"
                                        />
                                    </div>
                                    <Table data={returnByMemberLevel} caption={"สิทธิประโยชน์ตามระดับสมาขิก"}/> 
                                    <Table data={pointCalculation} caption={"การคำนวณแต้ม"}/> 
                                    <Table wrapClassName="prizes" data={prizes} caption={"โบนัสและของขวัญมากมาย"}/> 
                                    <Table wrapClassName="otherBenefit" data={otherBenefit} caption={"สิทธิประโยชน์อื่นๆ"}/> 
                                    <Table wrapClassName="expiration" data={expiration} caption={"วันหมดอายุของแต้ม"}/> 
                                    <div className="horizontalLine"/>
                                    <div className="condition_box">
                                        <h3 data-CN="條款與條件">
                                            ข้อกำหนดและเงื่อนไข:
                                        </h3>
                                        <ol className='ruleList'>
                                            {conditions.map((rule, i)=>{
                                                return <li key={i}>{rule}</li>;
                                            })}
                                        </ol>
                                    </div>
                                </div>
                            </TabPane>
                        </Tabs>
                    </div>
                </div>
            </Layout>
        );
    }
}


//幻灯片 *高機率會再復用 先不刪除， 若2025/06/30都未使用，可刪
class CarouselItem extends React.Component {
    render() {
        return (
            <Swiper
                spaceBetween={28}
                slidesPerView="3"
                className="diamond-slider"
                watchSlidesProgress={true}
            >
                {this.props.data &&
                    this.props.data.length != 0 &&
                    this.props.data.map((item, index) => {
                        return (
                            <SwiperSlide key={index + "list"}>
                                <img
                                    src={item.imageURL}
                                    alt="Fun88"
                                    style={{
                                        width: "315px",
                                        height: "180px",
                                        verticalAlign: "top",
                                    }}
                                />
                            </SwiperSlide>
                        );
                    })}
            </Swiper>
        );
    }
}
